interface PageHeaderProps {
  title: string;
  subtitle?: string;
}

const PageHeader = ({ title, subtitle }: PageHeaderProps) => (
  <div className="px-4 pt-4 pb-2">
    <h1 className="text-xl font-bold text-foreground">{title}</h1>
    {subtitle && <p className="text-sm text-muted-foreground mt-0.5">{subtitle}</p>}
  </div>
);

export default PageHeader;
